module.exports = "/_next/static/images/designed-for-ccb6546a8c4d139d81f7da9c083ca531.svg";